var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHomeWork = function SvgHomeWork(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "#e3e3e3",
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M680-600h80v-80h-80zm0 160h80v-80h-80zm0 160h80v-80h-80zm0 160v-80h160v-560H480v56l-80-58v-78h520v720zm-640 0v-400l280-200 280 200v400H360v-200h-80v200zm80-80h80v-200h240v200h80v-280L320-622 120-480zm320 0v-200H200v200-200h240z"
  })));
};
export default SvgHomeWork;